<div [attr.section-name]="sectionName"
     appIntersectionObserver
     (visibilityChange)="onVisibilityChanged($event)">
  <h3>Location</h3>

  <section>
    <app-editable-textual-input [fieldId]="'addressLine1'"
                                [iconName]="'house_outline'"
                                [isFieldWithDataSource]="isFieldWithDataSource('addressLine1')"
                                [hasActiveConnection]="hasActiveConnection('addressLine1') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'addressLine2'"
                                [isFieldWithDataSource]="isFieldWithDataSource('addressLine2')"
                                [hasActiveConnection]="hasActiveConnection('addressLine2') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'addressLine3'"
                                [isFieldWithDataSource]="isFieldWithDataSource('addressLine3')"
                                [hasActiveConnection]="hasActiveConnection('addressLine3') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'addressLine4'"
                                [isFieldWithDataSource]="isFieldWithDataSource('addressLine4')"
                                [hasActiveConnection]="hasActiveConnection('addressLine4') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'addressLine5'"
                                [isFieldWithDataSource]="isFieldWithDataSource('addressLine5')"
                                [hasActiveConnection]="hasActiveConnection('addressLine5') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'postalCode'"
                                [iconName]="'mail_outline'"
                                [isFieldWithDataSource]="isFieldWithDataSource('postalCode')"
                                [hasActiveConnection]="hasActiveConnection('postalCode') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'city'"
                                [iconName]="'location_city'"
                                [isFieldWithDataSource]="isFieldWithDataSource('city')"
                                [hasActiveConnection]="hasActiveConnection('city') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'district'"
                                [isFieldWithDataSource]="isFieldWithDataSource('district')"
                                [hasActiveConnection]="hasActiveConnection('district') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'state'"
                                [isFieldWithDataSource]="isFieldWithDataSource('state')"
                                [hasActiveConnection]="hasActiveConnection('state') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'country'"
                                [iconName]="'outlined_flag'"
                                [isFieldWithDataSource]="isFieldWithDataSource('country')"
                                [hasActiveConnection]="hasActiveConnection('country') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-coordinate-inputs [fieldId]="'coordinateImport'"
                                    [iconName]="'gps_fixed'"
                                    [isFieldWithDataSource]="isFieldWithDataSource('coordinateImport')"
                                    [hasActiveConnection]="hasActiveConnection('coordinateImport') | ngrxPush"
    ></app-editable-coordinate-inputs>

  </section>
</div>